import styles from './Contact.module.scss';
import { contact } from '../../data/resume';

export function Contact() {
  return (
    <section className="section container" id="contact" aria-label="Contact">
      <h2 className="sectionTitle">Contact</h2>
      <div className={styles.card}>
        <p>Open to back-end engineering and technical delivery roles. Let’s talk.</p>
        <div className={styles.actions}>
          <a className="badge" href={`mailto:${contact.email}`}>Email</a>
          <a className="badge" href={contact.linkedin} target="_blank" rel="noreferrer">LinkedIn</a>
          <a className="badge" href={contact.github} target="_blank" rel="noreferrer">GitHub</a>
          {contact.resume && <a className="badge" href={contact.resume} target="_blank" rel="noreferrer">Resume PDF</a>}
        </div>
      </div>
    </section>
  );
}